var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate } from 'ra-core';
import { Create } from '../ui';
import { ApplicationNew } from './ApplicationNew';
import { useUserContext } from '../userContexts';
const useTitleStyles = makeStyles(theme => ({
    root: {},
    title: {},
    status: {
        padding: theme.spacing(1, 0),
    },
}), {
    name: 'Layer7ApplicationTitle',
});
const useStyles = makeStyles({
    root: {},
    card: {},
}, {
    name: 'Layer7ApplicationCreate',
});
//TODO: proper translation for Title
const Title = (_a) => {
    var rest = __rest(_a, []);
    const classes = useTitleStyles(rest);
    const translate = useTranslate();
    return (React.createElement("div", { className: classes.root },
        React.createElement("span", { className: classes.title }, translate('resources.applications.actions.addApplication'))));
};
export const ApplicationCreate = props => {
    const _a = useStyles(props), { root: rootClassName } = _a, classes = __rest(_a, ["root"]);
    const { permissions, id } = props, rest = __rest(props, ["permissions", "id"]);
    const [userContext] = useUserContext();
    const [canCreateApp, setCanCreateApp] = React.useState(false);
    React.useEffect(() => {
        if (userContext && !userContext.userDetails.developer) {
            setCanCreateApp(true);
        }
    }, [userContext]);
    return (canCreateApp && (React.createElement(Create, Object.assign({ className: rootClassName, classes: classes, title: React.createElement(Title, null) }, rest),
        React.createElement(ApplicationNew, { userContext: userContext }))));
};
//# sourceMappingURL=ApplicationCreate.js.map